import { platform } from '@/Models';
import Resources from '@/Resources.js';
import { projectExplorationTagKeys } from './HomeUtilityConstants';
import {
    buildExploreProjectTags,
    buildCrowdfundingProjectTags,
    buildUpcomingProjectTags,
    buildLatePledgeProjectTags,
    buildMostDiscussedProjectTags,
    buildRecentlyAddedUpdatesProjectTags,
    buildHighestFundedProjectTags,
    buildPreordersProjectTags,
    buildTechAndInnovationTags,
    buildCreativeWorksTags,
    buildCommunityProjectsTags,
    buildGamingCultureTags,
    buildNewOnThePlatformTags,
} from './HomeUtilityTagBuilders';

export const buildGamefoundExploreList = () => {
    return [
        {
            title: Resources.Homepage.ExploreSectionTitle,
            icon: 'magnifying-glass',
            sectionKey: 'explore',
            items: buildExploreProjectTags(),
            defaultTagKey: projectExplorationTagKeys.exploreYouMayLike,
        },
        {
            title: Resources.Homepage.CrowdfundingProjectsSectionTitle,
            icon: 'rocket',
            sectionKey: 'crowdfunding',
            items: buildCrowdfundingProjectTags(),
            defaultTagKey: projectExplorationTagKeys.crowdfundingTrending,
        },
        {
            title: Resources.Homepage.UpcomingSectionTitle,
            icon: 'clock',
            sectionKey: 'upcoming',
            items: buildUpcomingProjectTags(),
            defaultTagKey: projectExplorationTagKeys.upcomingComingSoon,
        },
        {
            title: Resources.Homepage.NewOnThePlatformSectionTitle,
            sectionKey: 'newestProjects',
            items: buildNewOnThePlatformTags(),
            defaultTagKey: projectExplorationTagKeys.newOnThePlatformUpcoming,
        },
        {
            title: Resources.Homepage.LatePledgeProjectsSectionTitle,
            icon: 'shopping-bag',
            sectionKey: 'latePledge',
            items: buildLatePledgeProjectTags(),
            defaultTagKey: projectExplorationTagKeys.latePledgeNew,
        },
        {
            title: Resources.Homepage.MostDiscussedSectionTitle,
            sectionKey: 'mostDiscussed',
            items: buildMostDiscussedProjectTags(),
            defaultTagKey: projectExplorationTagKeys.mostDiscussedAll,
        },
        {
            title: Resources.Homepage.RecentlyAddedUpdatesSectionTitle,
            sectionKey: 'recentlyAddedUpdates',
            items: buildRecentlyAddedUpdatesProjectTags(),
            defaultTagKey: projectExplorationTagKeys.recentlyAddedUpdatesAll,
        },
        {
            title: Resources.Homepage.MostFundedSectionTitle,
            sectionKey: 'highestFunded',
            items: buildHighestFundedProjectTags(),
            defaultTagKey: projectExplorationTagKeys.highestFundedActive,
        },
        {
            title: Resources.Homepage.PreordersSectionTitle,
            sectionKey: 'preorders',
            items: buildPreordersProjectTags(),
            defaultTagKey: projectExplorationTagKeys.preorders,
        },
    ];
};

export const buildIdeafoundExploreList = () => {
    const filterUpcoming = i => i.key !== projectExplorationTagKeys.upcomingMostPopular;
    const filterCrowdfunding = i => i.key !== projectExplorationTagKeys.crowdfundingNew;

    return [
        {
            title: Resources.ProjectCatalogCategories.TechAndInnovation,
            sectionKey: 'techAndInnovation',
            items: buildTechAndInnovationTags(),
            defaultTagKey: projectExplorationTagKeys.techAndInnovationForYou,
        },
        {
            title: Resources.ProjectCatalogCategories.CreativeWorks,
            sectionKey: 'creativeWorks',
            items: buildCreativeWorksTags(),
            defaultTagKey: projectExplorationTagKeys.creativeWorksForYou,
        },
        {
            title: Resources.ProjectCatalogCategories.CommunityProjects,
            sectionKey: 'communityProjects',
            items: buildCommunityProjectsTags(),
            defaultTagKey: projectExplorationTagKeys.communityProjectsForYou,
        },
        {
            title: Resources.ProjectCatalogCategories.GamingCulture,
            sectionKey: 'gamingCulture',
            items: buildGamingCultureTags(),
            defaultTagKey: projectExplorationTagKeys.gamingCultureBoardAndCard,
        },
        {
            title: Resources.Homepage.NewOnThePlatformSectionTitle,
            sectionKey: 'newOnThePlatform',
            items: buildNewOnThePlatformTags(),
            defaultTagKey: projectExplorationTagKeys.newOnThePlatformUpcoming,
        },
        {
            title: Resources.Homepage.UpcomingSectionTitle,
            sectionKey: 'upcoming',
            items: buildUpcomingProjectTags(filterUpcoming),
            defaultTagKey: projectExplorationTagKeys.upcomingComingSoon,
        },
        {
            title: Resources.Homepage.CrowdfundingProjectsSectionTitle,
            sectionKey: 'crowdfunding',
            items: buildCrowdfundingProjectTags(filterCrowdfunding),
            defaultTagKey: projectExplorationTagKeys.crowdfundingTrending,
        },
        {
            title: Resources.Homepage.LatePledgeProjectsSectionTitle,
            sectionKey: 'latePledge',
            items: buildLatePledgeProjectTags(),
            defaultTagKey: projectExplorationTagKeys.latePledgeNew,
        },
        {
            title: Resources.Homepage.MostDiscussedSectionTitle,
            sectionKey: 'mostDiscussed',
            items: buildMostDiscussedProjectTags(),
            defaultTagKey: projectExplorationTagKeys.mostDiscussedAll,
        },
        {
            title: Resources.Homepage.MostFundedSectionTitle,
            sectionKey: 'highestFunded',
            items: buildHighestFundedProjectTags(),
            defaultTagKey: projectExplorationTagKeys.highestFundedActive,
        },
        {
            title: Resources.Homepage.RecentlyAddedUpdatesSectionTitle,
            sectionKey: 'recentlyAddedUpdates',
            items: buildRecentlyAddedUpdatesProjectTags(),
            defaultTagKey: projectExplorationTagKeys.recentlyAddedUpdatesAll,
        },
    ];
};

export function buildProjectsExploreListModel(platformType) {
    const platforms = {
        [platform.gamefound]: buildGamefoundExploreList,
        [platform.ideafound]: buildIdeafoundExploreList,
    };
    return platforms[platformType]();
}
